module.exports = __webpack_public_path__ + "SourceSansPro-BoldItalic.baacb5ac72c8834fc15e.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-BoldItalic.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-BoldItalic.woff
// module chunks = styles